import React, {
  useEffect,
  useState
} from "react";

import {
  useNavigate,
  useParams,
  useSearchParams
} from "react-router-dom";


function InlineSelectionNavbar({ darkMode, setDarkMode, activeNav = "Home" }) {
  const navigate = useNavigate();

  const [searchOpen, setSearchOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [accountName, setAccountName] = useState("Kids");

  useEffect(() => {
    try {
      localStorage.setItem("teacher_demo_theme", darkMode ? "dark" : "light");
    } catch (error) {}
  }, [darkMode]);

  const handleNavClick = (item) => {
    setMobileMenuOpen(false);

    if (item === "Home" || item === "Teachers" || item === "Subjects") {
      navigate("/teacher-demo");
      return;
    }

    if (item === "My Learning") {
      navigate("/profile");
    }
  };

  const themeToggle = () => {
    setDarkMode((current) => !current);
  };

  return (
    <>
      <style>{`
        .selection-navbar {
          position: sticky;
          top: 0;
          z-index: 5000;
          height: 72px;
          margin: 0 -40px 27px;
          padding: 0 48px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: linear-gradient(180deg, #050505 0%, #080808 100%);
          border-bottom: 1px solid rgba(255,255,255,.08);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
        }

        .selection-navbar-left,
        .selection-navbar-right,
        .selection-menu,
        .selection-search-area {
          display: flex;
          align-items: center;
        }

        .selection-navbar-left { gap: 32px; min-width: 0; }
        .selection-menu { gap: 8px; }
        .selection-navbar-right { gap: 10px; }

        .selection-menu button {
          border: none;
          background: transparent;
          padding: 10px 17px;
          color: rgba(255,255,255,.68);
          font-size: 16px;
          line-height: 20px;
          font-weight: 500;
          cursor: pointer;
          border-radius: 24px;
          white-space: nowrap;
          transition: .2s ease;
        }

        .selection-menu button:hover,
        .selection-menu button.active {
          background: #333338;
          color: #fff;
        }

        .selection-icon-button {
          width: 38px;
          height: 38px;
          border: none;
          border-radius: 50%;
          background: transparent;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          padding: 0;
          transition: .2s ease;
          flex-shrink: 0;
        }

        .selection-icon-button:hover,
        .selection-icon-button.active {
          background: #333338;
        }

        .selection-icon-button svg {
          width: 23px;
          height: 23px;
          display: block;
        }

        .selection-search-area { gap: 7px; }

        .selection-search-input {
          width: 220px;
          height: 36px;
          border: 1px solid rgba(255,255,255,.25);
          border-radius: 5px;
          outline: none;
          background: #181818;
          color: #fff;
          padding: 0 11px;
          font-size: 14px;
        }

        .selection-search-input::placeholder { color: rgba(255,255,255,.5); }

        .selection-kids-item {
          height: 38px;
          display: flex;
          align-items: center;
          gap: 7px;
          padding: 0 6px;
          border: none;
          border-radius: 6px;
          background: transparent;
          color: #fff;
          cursor: pointer;
        }

        .selection-kids-item:hover { background: #333338; }

        .selection-kids-logo {
          width: 32px;
          height: 32px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: linear-gradient(135deg,#8d42b9 0%,#d34f9d 48%,#f3b33d 48%,#f3b33d 100%);
        }

        .selection-kids-logo span {
          color: #fff;
          font-size: 9px;
          font-weight: 800;
          background: rgba(220,60,170,.75);
          padding: 2px 1px;
        }

        .selection-kids-text { font-size: 16px; font-weight: 500; }
        .selection-kids-arrow { width: 9px; height: 9px; }

        .selection-profile {
          display: flex;
          align-items: center;
          gap: 3px;
        }

        .selection-profile-icon {
          width: 38px;
          height: 38px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f2c900;
          color: #fff;
          cursor: pointer;
          border: none;
        }

        .selection-profile-icon svg { width: 24px; height: 24px; }
        .selection-profile-arrow { width: 10px; height: 10px; color: #aaa; }

        .selection-mobile-button { display:none; }

        .selection-mobile-panel {
          position: fixed;
          top: 72px;
          left: 12px;
          right: 12px;
          z-index: 4999;
          padding: 8px;
          border-radius: 8px;
          background: #181818;
          border: 1px solid rgba(255,255,255,.12);
          box-shadow: 0 15px 40px rgba(0,0,0,.65);
        }

        .selection-mobile-panel button {
          width:100%;
          height:44px;
          border:0;
          border-radius:6px;
          background:transparent;
          color:#ddd;
          text-align:left;
          padding:0 14px;
          font-size:15px;
          cursor:pointer;
        }

        .selection-mobile-panel button:hover,
        .selection-mobile-panel button.active {
          background:#333338;
          color:#fff;
        }

        .light-mode .selection-navbar {
          background: #fff;
          border-bottom-color: rgba(0,0,0,.10);
          box-shadow: 0 1px 8px rgba(0,0,0,.06);
        }

        .light-mode .selection-menu button { color: rgba(0,0,0,.68); }

        .light-mode .selection-menu button:hover,
        .light-mode .selection-menu button.active {
          background:#e7e7e7;
          color:#111;
        }

        .light-mode .selection-icon-button,
        .light-mode .selection-kids-item { color:#111; }

        .light-mode .selection-icon-button:hover,
        .light-mode .selection-icon-button.active,
        .light-mode .selection-kids-item:hover { background:#eeeeee; }

        .light-mode .selection-search-input {
          background:#f7f7f7;
          color:#111;
          border-color:rgba(0,0,0,.16);
        }

        .light-mode .selection-search-input::placeholder { color:rgba(0,0,0,.45); }

        .light-mode .selection-mobile-panel {
          background:#fff;
          border-color:rgba(0,0,0,.12);
          box-shadow:0 15px 40px rgba(0,0,0,.18);
        }

        .light-mode .selection-mobile-panel button { color:#333; }

        .light-mode .selection-mobile-panel button:hover,
        .light-mode .selection-mobile-panel button.active {
          background:#e8e8e8;
          color:#111;
        }

        @media (max-width: 900px) {
          .selection-navbar {
            padding:0 25px;
            margin-left:-25px;
            margin-right:-25px;
          }

          .selection-menu { gap:2px; }
          .selection-menu button { padding:10px; font-size:14px; }
        }

        @media (max-width: 768px) {
          .selection-navbar {
            height:72px;
            margin:0 -20px 25px;
            padding:0 20px;
          }

          .selection-menu { display:none; }
          .selection-mobile-button { display:flex; }
          .selection-navbar-right { gap:5px; }
          .selection-kids-text,
          .selection-profile-arrow { display:none; }

          .selection-search-input {
            position:absolute;
            right:105px;
            top:18px;
            width:170px;
          }
        }
      `}</style>

      <nav className="selection-navbar">
        <div className="selection-navbar-left">
          <button
            type="button"
            className="selection-icon-button selection-mobile-button"
            onClick={() => setMobileMenuOpen((v) => !v)}
            aria-label="Menu"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <path d="M4 7h16M4 12h16M4 17h16" />
            </svg>
          </button>

          <div className="selection-menu">
            {["Home", "Teachers", "Subjects", "My Learning"].map((item) => (
              <button
                key={item}
                type="button"
                className={activeNav === item ? "active" : ""}
                onClick={() => handleNavClick(item)}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        <div className="selection-navbar-right">
          <button
            type="button"
            className="selection-icon-button"
            onClick={themeToggle}
            aria-label="Toggle theme"
          >
            {darkMode ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <circle cx="12" cy="12" r="4" />
                <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5 8.5 8.5 0 1 0 20.5 14.5Z" />
              </svg>
            )}
          </button>

          <div className="selection-search-area">
            {searchOpen && (
              <input
                className="selection-search-input"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search..."
                autoFocus
              />
            )}

            <button
              type="button"
              className={`selection-icon-button ${searchOpen ? "active" : ""}`}
              onClick={() => setSearchOpen((v) => !v)}
              aria-label="Search"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
                <circle cx="10.8" cy="10.8" r="6.8" />
                <path d="m16 16 5 5" />
              </svg>
            </button>
          </div>

          <button type="button" className="selection-icon-button" aria-label="Notifications">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
              <path d="M10 21h4" />
            </svg>
          </button>

          <button
            type="button"
            className="selection-kids-item"
            onClick={() => setAccountName((current) => current === "Kids" ? "Kids" : "Kids")}
          >
            <span className="selection-kids-logo"><span>kids</span></span>
            <span className="selection-kids-text">{accountName}</span>
            <svg className="selection-kids-arrow" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M2 3.5 5 6.5 8 3.5" />
            </svg>
          </button>

          <div className="selection-profile">
            <button
              type="button"
              className="selection-profile-icon"
              onClick={() => navigate("/profile")}
              aria-label="Profile"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="8" cy="8" r="2.2" />
                <circle cx="16" cy="8" r="2.2" />
                <path d="M6 14c1.2 1.5 3.2 2.3 6 2.3s4.8-.8 6-2.3" />
              </svg>
            </button>
            <svg className="selection-profile-arrow" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M2 3.5 5 6.5 8 3.5" />
            </svg>
          </div>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="selection-mobile-panel">
          {["Home", "Teachers", "Subjects", "My Learning"].map((item) => (
            <button
              key={item}
              type="button"
              className={activeNav === item ? "active" : ""}
              onClick={() => handleNavClick(item)}
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </>
  );
}


function ModuleSelection() {

  const navigate = useNavigate();

  const [darkMode, setDarkMode] = useState(() => {
    try {
      return localStorage.getItem("teacher_demo_theme") !== "light";
    } catch (error) {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("teacher_demo_theme", darkMode ? "dark" : "light");
    } catch (error) {}

    document.body.style.backgroundColor = darkMode ? "#141414" : "#ffffff";
    document.documentElement.style.backgroundColor = darkMode ? "#141414" : "#ffffff";

    return () => {
      document.body.style.backgroundColor = "";
      document.documentElement.style.backgroundColor = "";
    };
  }, [darkMode]);

  const {
    gradeId,
    subjectId
  } = useParams();

  // FLOW 2:
  // teacher_id is present because the teacher was already selected.
  // Flow 1 does not have teacher_id here.
  const [searchParams] = useSearchParams();

  const teacherId = searchParams.get("teacher_id");

  // FLOW 3:
  // Subject -> Grade -> Module -> Teacher -> MCQ
  // The flow flag is passed from SubjectSelection.
  const flow = searchParams.get("flow");
  const isSubjectFirstFlow = flow === "subject-first";

  const isTeacherFirstFlow = Boolean(teacherId);


  const [modules, setModules] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  const MODULE_API =
    "https://edunet.kmechengineering.com/root-engine1/api/module-data";


  // =====================================================
  // LOAD MODULES
  // =====================================================

  useEffect(() => {

    const loadModules = async () => {

      setLoading(true);
      setError("");

      try {

        const response =
          await fetch(
            `${MODULE_API}?subject_id=${encodeURIComponent(
              subjectId
            )}`
          );

        if (!response.ok) {

          throw new Error(
            "Failed to load modules"
          );

        }

        const data =
          await response.json();

        setModules(
          data.module_data || []
        );

      } catch (error) {

        console.error(
          "Module API Error:",
          error
        );

        setModules([]);

        setError(
          "Unable to load modules."
        );

      } finally {

        setLoading(false);

      }

    };


    if (subjectId) {
      loadModules();
    }

  }, [subjectId]);


  // =====================================================
  // MODULE NAME
  // =====================================================

  const getModuleName = (
    module,
    index
  ) => {

    return (
      module.name ||
      module.module_name ||
      module.title ||
      module.module ||
      `Module ${index + 1}`
    );

  };


  // =====================================================
  // MODULE ID
  // =====================================================

  const getModuleId = (
    module,
    index
  ) => {

    return (
      module.module_id ||
      module.id ||
      module.moduleId ||
      index
    );

  };


  // =====================================================
  // MODULE CLICK
  // =====================================================

  const handleModuleClick = (
    module,
    index
  ) => {

    const moduleId =
      getModuleId(
        module,
        index
      );


    // Save selected module

    localStorage.setItem(
      "edunet_selected_grade_id",
      gradeId
    );

    localStorage.setItem(
      "edunet_selected_subject_id",
      subjectId
    );

    localStorage.setItem(
      "edunet_selected_module_id",
      moduleId
    );


    // =====================================================
    // FLOW 2
    // Teacher was already selected before Module.
    // Therefore go directly to MCQ.
    //
    // FreeMCQPage uses:
    // /mcq/free/teacher/:id?module_id=...
    // =====================================================
    if (isTeacherFirstFlow && teacherId) {
      navigate(
        `/mcq/free/teacher/${encodeURIComponent(
          teacherId
        )}?module_id=${encodeURIComponent(moduleId)}`
      );

      return;
    }

    // =====================================================
    // FLOW 3
    // Subject -> Grade -> Module -> Teacher -> MCQ
    // Keep grade + subject + module in the existing route.
    // TeacherSelection will handle the next step.
    // =====================================================
    if (isSubjectFirstFlow) {
      navigate(
        `/teacher-selection/${encodeURIComponent(
          gradeId
        )}/${encodeURIComponent(
          subjectId
        )}/${encodeURIComponent(
          moduleId
        )}?flow=subject-first`
      );

      return;
    }

    // =====================================================
    // FLOW 1
    // Keep the existing flow unchanged:
    // Grade -> Subject -> Module -> Teacher -> MCQ
    // =====================================================
    navigate(
      `/teacher-selection/${encodeURIComponent(
        gradeId
      )}/${encodeURIComponent(
        subjectId
      )}/${encodeURIComponent(
        moduleId
      )}`
    );

  };


  return (

    <div className={`module-selection-page ${darkMode ? "dark-mode" : "light-mode"}`} >

      <style>{`

        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          background: #141414;
        }

        .module-selection-page {

          min-height: 100vh;

          background:
            linear-gradient(
              180deg,
              #050505 0%,
              #141414 30%,
              #141414 100%
            );

          color: #fff;

          padding-bottom: 70px;

          font-family:
            Arial,
            Helvetica,
            sans-serif;
        }

        .module-page-content {

          padding: 42px 40px 0;
        }

        .module-back {

          border: none;

          background: transparent;

          color:
            rgba(255,255,255,.72);

          padding: 0;

          margin: 0 0 24px;

          cursor: pointer;

          font-size: 14px;
        }

        .module-back:hover {
          color: #fff;
        }

        .module-title {

          font-size: 30px;

          font-weight: 700;

          margin: 0 0 7px;
        }

        .module-subtitle {

          margin: 0 0 25px;

          color:
            rgba(255,255,255,.58);

          font-size: 14px;
        }

        .section-title {

          font-size: 19px;

          font-weight: 700;

          margin: 0 0 14px;
        }

        .module-row {

          display: grid;

          grid-template-columns:
            repeat(
              auto-fit,
              minmax(220px, 1fr)
            );

          gap: 14px;

          width: 100%;
        }

        .module-card {

          min-height: 125px;

          border-radius: 7px;

          position: relative;

          overflow: hidden;

          cursor: pointer;

          border:
            1px solid
            rgba(255,255,255,.05);

          background:
            linear-gradient(
              135deg,
              #252525,
              #111
            );

          transition:
            transform .25s ease,
            box-shadow .25s ease,
            border-color .25s ease;
        }

        .module-card:hover {

          transform:
            scale(1.035);

          box-shadow:
            0 15px 40px
            rgba(0,0,0,.65);

          border-color:
            rgba(255,255,255,.14);
        }

        .module-card::after {

          content: "";

          position: absolute;

          inset: 0;

          background:
            linear-gradient(
              180deg,
              transparent 20%,
              rgba(0,0,0,.9) 100%
            );
        }

        .module-number {

          position: absolute;

          top: 15px;
          left: 17px;

          z-index: 5;

          font-size: 12px;

          color:
            rgba(255,255,255,.58);
        }

        .module-name {

          position: absolute;

          left: 17px;
          right: 17px;
          bottom: 17px;

          z-index: 5;

          font-size: 20px;

          font-weight: 700;

          color: #fff;
        }

        .module-loading,
        .module-empty,
        .module-error {

          padding: 45px 0;

          color: #999;

          font-size: 14px;
        }

        .module-error {
          color: #ff7777;
        }


        /* =================================================
           LIGHT MODE
        ================================================= */

        .module-selection-page.light-mode {
          background: #ffffff;
          color: #111;
        }

        .light-mode .module-title { color: #111; }
        .light-mode .module-subtitle { color: rgba(0,0,0,.58); }
        .light-mode .section-title { color: #111; }
        .light-mode .module-back { color: rgba(0,0,0,.68); }
        .light-mode .module-back:hover { color: #111; }

        .light-mode .module-card {
          background: linear-gradient(135deg, #f3f3f3, #dedede);
          border-color: rgba(0,0,0,.08);
          box-shadow: 0 8px 24px rgba(0,0,0,.05);
        }

        .light-mode .module-card::after {
          background: linear-gradient(180deg, transparent 20%, rgba(0,0,0,.12) 100%);
        }

        .light-mode .module-number { color: rgba(0,0,0,.52); }
        .light-mode .module-name { color: #111; }

        .light-mode .module-loading,
        .light-mode .module-empty,
        .light-mode .module-error { color: #666; }

        @media(max-width:768px) {

          .module-page-content {
            padding: 30px 20px 0;
          }

          .module-title {
            font-size: 25px;
          }

          .module-row {
            grid-template-columns: 1fr;
          }

        }

      `}</style>


      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <InlineSelectionNavbar darkMode={darkMode} setDarkMode={setDarkMode} activeNav="Home" />


      {/* =====================================================
          CONTENT
      ===================================================== */}

      <main className="module-page-content">

        <button
          className="module-back"
          onClick={() => navigate(-1)}
        >
          ← Back to Subjects
        </button>


        <h1 className="module-title">
          Modules
        </h1>


        <p className="module-subtitle">
          Select a module to continue learning
        </p>


        {loading ? (

          <div className="module-loading">
            Loading modules...
          </div>

        ) : error ? (

          <div className="module-error">
            {error}
          </div>

        ) : modules.length === 0 ? (

          <div className="module-empty">
            No modules available.
          </div>

        ) : (

          <section>

            <h2 className="section-title">
              Modules
            </h2>


            <div className="module-row">

              {modules.map(
                (module, index) => (

                  <div
                    key={getModuleId(
                      module,
                      index
                    )}

                    className="module-card"

                    onClick={() =>
                      handleModuleClick(
                        module,
                        index
                      )
                    }
                  >

                    <div className="module-number">

                      {String(
                        index + 1
                      ).padStart(2, "0")}

                    </div>


                    <div className="module-name">

                      {getModuleName(
                        module,
                        index
                      )}

                    </div>

                  </div>

                )
              )}

            </div>

          </section>

        )}

      </main>

    </div>

  );

}

export default ModuleSelection;
